/**
 * System Role UUIDs
 * These are fixed system roles that won't change
 * Defined in the crm_user_roles table
 */
export const ROLE_UUIDS = {
  SUPER_ADMIN: "54ab3bb1-017d-4cb9-80a7-44a6d981abb4",
  SYSTEM_ADMIN: "4f0980ab-3713-4945-b695-103a94219fc6",
  SALES_DIRECTOR: "71f7e19a-3f90-4f7f-9500-8f90ac3caa0f",
  SALES_MANAGER: "d9c21ee6-1f36-4c62-be14-232f7d55d27e",
  TEAM_LEAD: "6fb95c85-e1db-4af5-a05a-2389feaa3454",
  SENIOR_SALES_REP: "52e0f092-60f9-4d93-be47-a9f853b1e23b",
  SALES_REP: "cdebf71f-c1ae-40fe-bb5f-bbe125c74f6c",
  JUNIOR_SALES_REP: "e21e5bec-46f6-4da3-b3ae-bb14be81e241",
  SUPPORT_MANAGER: "13240dfd-9f36-4996-937b-e87c53a2dd1d",
  READ_ONLY: "f9025325-a52b-4365-9106-0323a05b98b0"
} as const;

/**
 * Roles that have full admin access
 * Can access all admin features including session management
 */
export const ADMIN_ROLES = [
  ROLE_UUIDS.SUPER_ADMIN,
  ROLE_UUIDS.SYSTEM_ADMIN
] as const;

/**
 * Roles that have admin or manager level access
 * Can access most settings and administrative features
 */
export const ADMIN_MANAGER_ROLES = [
  ROLE_UUIDS.SUPER_ADMIN,
  ROLE_UUIDS.SYSTEM_ADMIN,
  ROLE_UUIDS.SALES_DIRECTOR,
  ROLE_UUIDS.SALES_MANAGER,
  ROLE_UUIDS.SUPPORT_MANAGER
] as const;

/**
 * Check if a role UUID is an admin role
 */
export const isAdminRole = (roleUuid: string): boolean => {
  return ADMIN_ROLES.includes(roleUuid as any);
};

/**
 * Check if a role UUID is an admin or manager role
 */
export const isAdminOrManagerRole = (roleUuid: string): boolean => {
  return ADMIN_MANAGER_ROLES.includes(roleUuid as any);
};
